import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import UserLayout from "layouts/User.js";
import { AuthProvider } from "context/AuthContext";
import MedicalCondition from "views/Admin/MedicalCondition";
import CreateMedicalCondition from "views/Admin/CreateMedicalCondition";
import Blogs from "views/Admin/Blogs";
import CreateBlog from "views/Admin/CreateBlog";
import Education from "views/Admin/EducationalResources/Education";
import CreateEducation from "views/Admin/EducationalResources/CreateEducation";
import EducationalPage from "views/users/educational";
import Educational from "views/users/View More/Educational";
import BlogPage from "views/users/blog";
import Blog from "views/users/View More/Blog";
import Condition from "views/users/condition";
import Conditions from "views/users/View More/Conditions";
import Faq from "views/Admin/FAQ/FaqList";
import CreateFaq from "views/Admin/FAQ/CreateFaq";
import CreateUser from "views/Admin/Users/CreateUser";
import UserList from "views/Admin/Users/User";
import QuestionList from "views/Admin/QuestionList";
import EditQuestion from "views/Admin/EditQuestion";
import { PageLoader } from "components/pageLoader";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <PageLoader />
    <AuthProvider>
      <Routes>
        <Route path="/admin/*" element={<AdminLayout />}>
          <Route path="medical-condition" element={<MedicalCondition />}>
            <Route
              path="create-medical-condition"
              element={<CreateMedicalCondition />}
            />
            <Route
              path="edit-medical-condition/:id?"
              element={<CreateMedicalCondition />}
            />
          </Route>
          <Route path="questions" element={<QuestionList />}>
            <Route path="edit-question/:id?" element={<EditQuestion />} />
          </Route>
          <Route path="blog" element={<Blogs />}>
            <Route path="create-blog" element={<CreateBlog />} />
            <Route path="edit-blog/:id?" element={<CreateBlog />} />
          </Route>

          <Route path="educational-resource" element={<Education />}>
            <Route
              path="create-educational-resource"
              element={<CreateEducation />}
            />
            <Route
              path="edit-educational-resource/:id?"
              element={<CreateEducation />}
            />
          </Route>
          <Route path="faq" element={<Faq />}>
            <Route path="create-faq" element={<CreateFaq />} />
            <Route path="edit-faq/:id?" element={<CreateFaq />} />
          </Route>
          <Route path="users" element={<UserList />}>
            <Route path="create-user" element={<CreateUser />} />
            <Route path="edit-user/:id?" element={<CreateUser />} />
          </Route>
        </Route>
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="/*" element={<UserLayout />}>
          <Route path="educational-info" element={<EducationalPage />}>
            <Route
              path="view-educational-resource/:id?"
              element={<Educational />}
            />
          </Route>
          <Route path="blogs" element={<BlogPage />}>
            <Route path="view-blogs/:id?" element={<Blog />} />
          </Route>
          <Route path="conditions" element={<Condition />}>
            <Route path="view-conditions/:id?" element={<Conditions />} />
          </Route>
        </Route>
        <Route
          path="/admin/*"
          element={<Navigate to="/admin/dashboard" replace />}
        />
      </Routes>
    </AuthProvider>
  </BrowserRouter>
);
